export function register() {
  // Registra somente em produção e se suportado pelo navegador
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', async () => {
    // RDS-SW-FIX: apuntaba a "/service-worker.js", que nunca existió en el
    // build -- caía en el catch-all de Express (app.get("/*", ...index.html)),
    // devolviendo HTML en vez de JS. El chequeo de Content-Type de abajo
    // abortaba el registro silenciosamente, dejando cualquier Service Worker
    // ya instalado de una version anterior sin forma de actualizarse nunca
    // (el navegador solo revisa updates cuando se vuelve a llamar
    // .register()). El archivo real generado por CRA es sw.js.
    const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

    try {
      // Valida existência do arquivo e MIME adequado (javascript)
      const response = await fetch(swUrl, { method: 'HEAD' });
      const contentType = response.headers.get('content-type') || '';
      if (!response.ok || !contentType.includes('javascript')) {
        console.warn('Service worker não registrado (arquivo ausente ou MIME inválido).', {
          status: response.status,
          contentType
        });
        return;
      }

      const registration = await navigator.serviceWorker.register(swUrl);
      console.log('Service worker registrado com sucesso!', registration);

      // RDS-SW-AUTOUPDATE: sw.js ya llama self.skipWaiting() + self.clients.claim()
      // sin condiciones (no se tocó esa estrategia), asi que un Service Worker
      // nuevo toma control apenas se instala. Sin este listener, la PESTAÑA YA
      // ABIERTA seguia usando el JS viejo en memoria hasta que el usuario la
      // cerrara manualmente.
      //
      // RDS-PWA-CRM: antes esto hacía window.location.reload() en silencio.
      // Ahora, si YA había un controller activo (o sea: esto es una
      // actualización real reemplazando una versión anterior, no la primera
      // activación de este SW en esta pestaña), se avisa con un toast visible
      // (UpdateBanner) en vez de recargar sin que el usuario se entere -- la
      // lección directa del incidente con la app legacy de Agenda. Si es la
      // primera activación (no había nada "viejo" que el usuario estuviera
      // viendo), se mantiene el reload silencioso original.
      const hadControllerBefore = !!navigator.serviceWorker.controller;
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        if (hadControllerBefore) {
          window.dispatchEvent(new CustomEvent('shessai:sw-update-ready'));
        } else {
          window.location.reload();
        }
      });
    } catch (error) {
      console.error('Erro durante o registro do service worker:', error);
    }
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('Erro durante o desregistro do service worker:', error);
      });
  }
}
